module.exports = __webpack_public_path__ + "static/img/xs1-10.4d6dc66.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-10.png
// module id = 809
// module chunks = 0